// ============================================
// OrderCodeCell - Blue Order Code Display
// PO-xxxx code with blue text, clickable
// ============================================

import { cn } from '../../../utils/cn';

// ============================================
// Types
// ============================================

interface OrderCodeCellProps {
  code: string;
  onClick?: () => void;
  className?: string;
}

// ============================================
// Component
// ============================================

export function OrderCodeCell({
  code,
  onClick,
  className,
}: OrderCodeCellProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={cn(
        'text-left text-sm font-semibold text-[#004AC6]',
        'cursor-pointer hover:underline focus:outline-none focus:ring-2 focus:ring-primary-500/50 focus:ring-offset-1',
        'transition-colors',
        className
      )}
    >
      {code}
    </button>
  );
}

// ============================================
// Helper: Format import number to PO code
// ============================================

export function formatOrderCode(importNumber: unknown): string {
  const safeCode = typeof importNumber === 'string' ? importNumber.trim() : '';

  if (!safeCode) {
    return 'PO-N/A';
  }

  // If already has PO- prefix, return as is
  if (safeCode.startsWith('PO-')) {
    return safeCode;
  }

  // Add PO- prefix
  return `PO-${safeCode}`;
}
